/**
 * Where to go after signing in (plan M7 step 7j): a path on this site only,
 * never another origin, so a link cannot send the person elsewhere.
 */
export function safeNext(raw: string | null | undefined, origin: string): string | null {
  if (!raw || !raw.startsWith("/") || raw.startsWith("//") || raw.includes("\\")) return null;
  try {
    const url = new URL(raw, origin);
    return url.origin === origin ? `${url.pathname}${url.search}` : null;
  } catch {
    return null;
  }
}
